module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-gdpr-cookies/gatsby-browser.js'),
      options: {"plugins":[],"googleAnalytics":{"trackingId":"UA-128887824-5","autoStart":false,"anonymize":false,"cookieName":"isCookiesGranted"},"googleTagManager":{"trackingId":"GTM-P3RG4QB","cookieName":"isCookiesGranted","dataLayerName":"dataLayer"},"hotjar":{"hjid":"2560032","hjsv":"6","cookieName":"isCookiesGranted"},"debug":false,"environments":["production","development"]},
    },{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
